var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24656 16.1855H7.49656L8.24656 10.9355H5.62156C4.96156 10.9355 5.37406 10.373 5.38906 10.3505C6.35656 8.64055 7.81156 6.09055 9.75406 2.68555H10.5041L9.75406 7.93555H12.3866C12.6866 7.93555 12.8516 8.07805 12.6866 8.43055C9.72406 13.598 8.24656 16.1855 8.24656 16.1855Z",
    fill: "#F1B315"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltIcon);
export default __webpack_public_path__ + "static/media/bolt_icon.c2721a92dfe5ea735f3c15ba3c8ba120.svg";
export { ForwardRef as ReactComponent };